import { createRequiredContext } from 'ha/core/RequiredContext';
import { InboxState } from '../types';

export const InboxContext = createRequiredContext<InboxState>('InboxContext');
